<script setup lang="ts">
import { Head } from '@inertiajs/vue3'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Icon from '@/Components/Utils/Icon.vue'
import CountUp from 'vue-countup-v3'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import { useFormatNumber } from '@/Composables/useFormatNumber'
import { onMounted, ref } from 'vue'
import Chart from 'primevue/chart'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import {  } from '@fas'
// import { library } from '@fortawesome/fontawesome-svg-core'
// library.add()

const props = defineProps<{
    pageHead?: PageHeadingTS
    title?: string
    stats: {
        total_order: {
            value: number
        }
        orders_not_paid: {
            value: number
        }
        orders_this_month: {
            value: number
        }
    }
    order_graph: {}
}>()

console.log('order_graph', props.order_graph)


const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--p-text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
    const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

    return {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
            legend: {
                labels: {
                    color: textColor
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            },
            y: {
                ticks: {
                    color: textColorSecondary
                },
                grid: {
                    color: surfaceBorder
                }
            }
        }
    };
}
const isChartLoaded = ref(false)
const chartOptions = ref<typeof setChartOptions | null>(null)
onMounted(() => {
    chartOptions.value = setChartOptions()
})
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />

    <div class="mx-8 mt-6 gap-x-6 gap-y-8 xl:gap-x-6 ">
        <div class="col-span-2">
            <div class="border-l-4 text-xl border-sky-400 pl-2 pr-4 bg-sky-50 w-fit py-1">
                Grafik orderan perbulan
                <!-- <FontAwesomeIcon v-tooltip="'Sesuai kuantitas yang ada di Invoice'" icon='fal fa-info-circle' class='text-gray-400' fixed-width aria-hidden='true' /> -->
            </div>
            <Chart v-show="isChartLoaded" @loaded="isChartLoaded = true" type="line" :data="order_graph" :options="chartOptions" class="h-[20rem]" />
            <div v-show="!isChartLoaded" class="h-[20rem] skeleton w-full"></div>
            <!-- {{ chartOptions }} -->
        </div>

        <!-- Section: Stats box -->
        <div class="mt-8 w-full grid grid-cols-2 gap-x-2 gap-y-1.5 md:grid-cols-4">            
            <div
                class="relative md:col-span-2 px-4 py-6 sm:px-6 lg:px-8 rounded border border-gray-200">
                <p class="text-sm/6 font-medium text-gray-400">Total orderan</p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats.total_order.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <!-- <Icon v-if="stats.total_order.icon" :data="stats.total_order.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>

            <div
                class="relative px-4 py-6 sm:px-6 lg:px-8 rounded border border-gray-200">
                <p class="text-sm/6 font-medium text-gray-400">Order bulan ini</p>
                <p class="text-4xl mt-2 flex items-baseline">
                    +
                    <span class="font-semibold tracking-tight">
                        <CountUp :endVal='stats.orders_this_month.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <!-- <Icon v-if="stats.total_order.icon" :data="stats.total_order.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>

            <div
                class="relative px-4 py-6 sm:px-6 lg:px-8 rounded border border-red-400 bg-red-100 text-red-500">
                <p class="text-sm/6 font-medium ">
                    Order belum lunas
                    <FontAwesomeIcon v-tooltip="'Tidak termasuk yang dicancel'" icon='fal fa-info-circle' class='opacity-70' fixed-width aria-hidden='true' />
                </p>
                <p class="mt-2 flex items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats.orders_not_paid.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <!-- <Icon v-if="stats.total_order.icon" :data="stats.total_order.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>
        </div>
    </div>
</template>